import React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

// Main
// import Signin from '../components/Signin';
// import PasswordResetLink from '../components/PasswordRequestLink';
// import ConfirmationResetPassword from '../components/ConfirmationResetPassword';
// import ResetPassword from '../components/ResetPassword';
// import PasswordUpdatedConfirmation from '../components/installer/PasswordUpdatedConfirmation';

const Signin = loadable(() => import('../components/Signin'));
const PasswordResetLink = loadable(() =>
  import('../components/PasswordRequestLink')
);
const ConfirmationResetPassword = loadable(() =>
  import('../components/ConfirmationResetPassword')
);
const ResetPassword = loadable(() => import('../components/ResetPassword'));
const PasswordUpdatedConfirmation = loadable(() =>
  import('../components/installer/PasswordUpdatedConfirmation')
);
const UpdatePassword = loadable(() => import('../components/UpdatePassword'));
const TermsAndConditions = loadable(() =>
  import('../components/TermsAndConditions')
);
const Cookies = loadable(() => import('../components/Cookies'));
const PrivacyPolicy = loadable(() => import('../components/PrivacyPolicy'));
const AccessibilityStatement = loadable(() =>
  import('../components/AccessibilityStatement')
);

export default function RoutesTree() {
  return (
    <Switch>
      {/* ******************** */}
      {/* Generic user routes  */}
      {/* ******************** */}
      <Route exact path="/signin">
        <Signin />
      </Route>
      <Route exact path="/password-reset-link">
        <PasswordResetLink />
      </Route>
      <Route exact path="/password-reset-confirmation">
        <ConfirmationResetPassword />
      </Route>
      <Route exact path="/reset-password/:encodedEmail/:encodedOtp">
        <ResetPassword />
      </Route>
      <Route exact path="/password-updated-confirmation">
        <PasswordUpdatedConfirmation />
      </Route>
      <Route exact path="/update-password">
        <UpdatePassword />
      </Route>
      <Route exact path="/terms-and-conditions">
        <TermsAndConditions />
      </Route>
      <Route exact path="/cookies">
        <Cookies />
      </Route>
      <Route exact path="/privacy-policy">
        <PrivacyPolicy />
      </Route>
      <Route exact path="/accessibility-statement">
        <AccessibilityStatement />
      </Route>
    </Switch>
  );
}
